
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#8689A4","d":"M24.958 19.795a.556.556 0 00-.514-.334h-2.67l1.068-5.828a.535.535 0 00-.29-.572.57.57 0 00-.648.095l-6.739 6.461a.527.527 0 00-.123.588.555.555 0 00.514.333h2.67l-1.067 5.83a.533.533 0 00.289.57.56.56 0 00.648-.094l6.739-6.461a.527.527 0 00.123-.588zm-6.4 5.091l.878-4.792c.029-.157-.015-.318-.121-.44s-.262-.192-.426-.192h-1.982l4.535-4.348-.878 4.792c-.029.157.015.318.121.44s.262.192.426.192h1.982l-4.535 4.348z"}}),_c('rect',{attrs:{"width":"39","height":"39","x":".5","y":".5","stroke":"#D5D8E5","rx":"5.5"}})])
          )
        }
      }
    